//import Immutable from 'immutable';
import {USER_LOGIN, USER_LOGOUT, USER_SET_AGENT, APP_CLEAR} from '../constants/actionTypes';

const initialState ={  
  isLogged: false,  
  userName: '---',
  agentName: '',
  agentLogin: '',
  agents:[],
  userLogin: '',
  apiUser:'',  
};
 
const userReducer = (state = initialState, action) => {
  switch (action.type) {
//    case USER_SET_LOGIN_DATA:      
//      return { 
//        ...state, 
//        isLogged: true,
//        userName: action.loginData.username,
//        loginData: action.loginData
//      }
//    case USER_SET_MBAUTH_DATA:      
//      return { 
//        ...state, 
//        isLogged: true, 
//        apiUser: action.apiData.user,
//        apiKey: action.apiData.key,
//        userName: action.apiData.fullName,        
//      }
    case USER_LOGIN:
      var logData=action.loginData
      return { 
        ...state, 
        isLogged: true,
        ...logData        
      }
    case USER_SET_AGENT:
      var agLogin=action.agentLogin;
      for (var i=0;i<state.agents.length;i++){
        var currAgent=state.agents[i];
        if (currAgent.LoginName===agLogin){
          return {
            ...state,
            agentLogin: agLogin,
            agentName: currAgent.ShortName,
            agentCompanies: currAgent.Companies,
          }
        }
      }
      return state;
    case USER_LOGOUT:  
    case APP_CLEAR:
      return {
        ...state, 
        isLogged: false,
        userName: 'Niezalogowany',
        apiUser: '',        
      }
    default:
      return state;
   }
};
 
export default userReducer;


// WEBPACK FOOTER //
// ./src/reducers/userReducer.js